let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7WL1U")).then(() => parcelRequire('f6cEN'));